export default "__VITE_ASSET__8617a669__"